import React, { PropTypes } from 'react';
import axios from './../../../../constants/axios';
import { Table } from 'react-bootstrap';

class SaleReturnInvoiceDetailPaymentHistory extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         invoicePaymentHistory: []
      };
   }

   componentDidMount() {
      const { invoiceId } = this.props.params;
      axios.get(`saleReturns/getInventoryPaymentHistoryByInvoiceId/${invoiceId}`)
         .then((res) => {
            this.setState({
               invoicePaymentHistory: res.data
            });
         });
   }

   render() {
      const { invoicePaymentHistory } = this.state;
      return (
         <div>
            <h4>Invoice Payment History</h4>
            <Table>
               <thead>
               <tr>
                  <th>Id</th>
                  <th>Amount</th>
                  <th>Account</th>
                  <th>Time</th>
               </tr>
               </thead>
               <tbody>
               {invoicePaymentHistory.map((history) => (
                  <tr key={history.id} >
                     <td>{history.id}</td>
                     <td>{history.amount}</td>
                     <td>{history.chart_of_account_name}</td>
                     <td>{history.event_time}</td>
                  </tr>
               ))}
               </tbody>
            </Table>
         </div>
      );
   }
}

SaleReturnInvoiceDetailPaymentHistory.propTypes = {
   params: PropTypes.object
};

export default SaleReturnInvoiceDetailPaymentHistory;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/SaleReturn/SaleReturnInvoiceDetails/SaleReturnInvoiceDetailPaymentHistory.js
 **/